// src/blocks/move/moveRight.ts

import * as Blockly from 'blockly';
import { javascriptGenerator } from 'blockly/javascript';
import { BlocklyFields } from '../../BlocklyFields';
import i18next from 'i18next';

export function initJumpRightBlock() {

    Blockly.Blocks[BlocklyFields.JUMP_RIGHT] = {
        init: function () {
            this.jsonInit({
                "type": BlocklyFields.JUMP_RIGHT,
                "message0": '%1 ' + i18next.t('blockly.jump.right.message', 'Jump right'),
                "args0": [
                    {
                        "type": "field_image",
                        "src": "/images/blocks/right.png", // Lien vers votre icône (chemin relatif ou absolu)
                        "width": 16,   // Largeur de l'image
                        "height": 16,  // Hauteur de l'image

                    }
                ],
                "previousStatement": null,
                "nextStatement": null,
                "colour": '#3A7DD8',
                "tooltip": i18next.t('blockly.jump.right.tooltip', ''),
                "helpUrl": ""
            });
        },
    };
    javascriptGenerator.forBlock[BlocklyFields.JUMP_RIGHT] = function (block, generator) {
        return 'await jumpCharacter(0);\n';
    }
}
